import { MDM_ADMINS_ROLES, TSM_ROLES } from 'src/app/core/constants/roles.constant';
import { Menu } from '../models/menu.model';

export enum MenuItemsEnum {
	Admin_Assignment = 10,
	Technician_Assignment = 20,
	Device_Reporting = 30,
	Soti_Bulk_Remove = 40,
}

export const menuItems = [
	new Menu(
		MenuItemsEnum.Admin_Assignment,
		`Admin User Assignment`,
		'/assignment/admin',
		null,
		'assignment',
		null,
		null,
		false,
		0,
		[...MDM_ADMINS_ROLES]
	),
	new Menu(
		MenuItemsEnum.Device_Reporting,
		`Device Reporting`,
		'/reporting/audit',
		null,
		'analytics',
		null,
		null,
		false,
		0,
		[...MDM_ADMINS_ROLES]
	),
	new Menu(
		MenuItemsEnum.Soti_Bulk_Remove,
		`SOTI Bulk Remove`,
		'/management/soti-remove',
		null,
		'remove_circle',
		null,
		null,
		false,
		0,
		[...MDM_ADMINS_ROLES]
	),
	new Menu(
		MenuItemsEnum.Technician_Assignment,
		`Technician User Assignment`,
		'/assignment/technician',
		null,
		'assignment_ind',
		null,
		null,
		false,
		0,
		[...MDM_ADMINS_ROLES, ...TSM_ROLES]
	)
];
